import { API_BASE } from '../env'
import { request } from './http'

// The user documentation (Plans/user-documentation.md) is a static site nginx serves at /docs/ only to a request
// carrying the relay's docs cookie. These trade the signed-in session for that cookie and take it back.

/** Sets the docs cookie for the signed-in caller. Any account that can sign in may read the docs. */
export function startDocsSession(): Promise<string> {
  return request<string>('POST', `${API_BASE}/docs/session`, { accept: 'text' })
}

/** Clears the docs cookie: signing out of the portal signs out of the docs too. */
export function endDocsSession(): Promise<string> {
  return request<string>('DELETE', `${API_BASE}/docs/session`, { accept: 'text', stepUpRetry: false })
}
